<template>
  <div class="app-container">
    <!-- 轮播 banner -->
    <div class="banner-box" v-if="isToolbar">
      <div class="swiper">
        <el-carousel indicator-position="outside">
          <el-carousel-item :interval="5000" v-for="(item,index) in bannerList" :key="index">
            <div class="img" :style="{'background-image': 'url('+item.url+')'}"></div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 筛选 -->
      <div class="search-box">
        <div class="search-input">
          <!-- <el-select v-model="searchItem" placeholder="请选择">
                        <el-option v-for="(item,index) in searchOptions" :key="index" :label="item" :value="item"></el-option>
                    </el-select> -->
          <el-input placeholder="模糊搜索素材标签/项目" v-model="search" clearable @input="handleInput" @keyup.enter.native="handleFilter"></el-input>
          <i class="el-icon-search searchButn" @click="handleFilter"></i>
        </div>
        <div class="search-text">
          <label>热搜词：</label>
          <!-- <el-radio-group size="mini" v-model="heatValue" @change="handeleHeat">
                        <el-radio-button v-for="(item,index) in heatOptions" :key="index" :label="item.name"></el-radio-button> 
                    </el-radio-group> -->

          <template v-for="(item,index) in heatOptions">
            <el-button size="mini" :key="index" type="text" :style="{color:heatValue == item.id ? '#409EFF' : '#606266'}" @click="handeleHeat(item)">{{item.name}}</el-button>
          </template>
        </div>
      </div>
    </div>

    <!-- 工具栏 筛选条件 -->
    <toolbar ref="toolbar" source="allMaterial" @filterSubmit="filterSubmit" v-if="isToolbar"></toolbar>

    <!-- 文件列表 -->
    <file-list ref="file" :isOpenFolder="isOpenFolder" source="allMaterial" :pageSize="pageSize" :breadcrumbList="breadcrumbList" :sourceList="fileList" :checkedTags='checkedTags' @emptyTags="handleEmpty" @closeTag="handleClose" @refreshList="getList" @handleFilter="handleFilter" @openFolder="openFolder" @goBack="handleGoback"></file-list>

  </div>
</template>

<script>
import FileList from './components/fileList'
import Toolbar from './components/toolbar.vue'
import { searchList_ajax, hotWords_ajax, folderTreeByPid_ajax } from '@File~/api/file'

export default {
  components: { Toolbar, FileList },
  data() {
    return {
      bannerList: [
        {
          url: require('../../assets/banner1.png')
        },
        {
          url: require('../../assets/banner2.png')
        },
      ],
      search: '',
      // searchItem:'图片',
      // searchOptions:['图片','视频','文件'],
      heatValue: '',
      heatOptions: [],

      isToolbar: true,
      isOpenFolder: false,
      breadcrumbList: [],
      fileList: [],

      checkedTags: [],

      pageSize: 36,
    }
  },

  mounted() {
    this.getHotWords() // 热搜词
    setTimeout(() => {
      this.getList() // 获取列表
    }, 300);

  },

  methods: {
    // 获取列表
    getList(folderPid, containsChildren) {
      const toolbar = this.$refs['toolbar'] // 筛选条件
      const file = this.$refs['file']

      file.loading = true

      let fileType = []  // 文件类型
      let taskIds = [] // 用途
      let labelIds = [] // 其他所有标签
      toolbar.resultSelected.forEach(t => {
        if (t.labelType == 'fileType') { // 文件类型
          fileType = t.checkeds
        } else if (t.labelType == 'taskIds') { // 用途
          taskIds = t.checkeds
        } else {
          labelIds = labelIds.concat(t.checkeds)
        }
      })

      const data = {
        pageNo: file.listQuery.pageNo,
        pageSize: this.pageSize,
        orderByType: file.orderByType,
        keyword: this.search, // 模糊搜索词条
        createTime: toolbar.createTime && toolbar.createTime.length > 0 ? toolbar.createTime[0] + ' - ' + toolbar.createTime[1] : '',
        projectIds: toolbar.projectIds,
        designerIds: toolbar.designerIds,
        labelIds: labelIds,
        fileType: fileType,
        taskIds: taskIds,
        folderPid: folderPid ? folderPid : '',
        showType: 1,
        containsChildren: containsChildren ? containsChildren : 0,
        fileStatus: 1,
        inOut: this.$store.getters.synchro,
      }
      searchList_ajax(data).then(response => {
        file.loading = false
        if (response.code == 1) {
          this.fileList = response.data.result
          file.total = response.data.totalCount
        }
      })
    },

    // 获取热搜词列表
    getHotWords() {
      hotWords_ajax().then(response => {
        if (response.code == 1) {
          this.heatOptions = response.data
        }
      })
    },

    // 搜索
    handleFilter() {
      this.$refs['file'].listQuery.pageNo = 1
      if (this.search) {
        this.getList('', 1)
      } else {
        this.getList()
      }
    },

    // 监听搜索框
    handleInput(val) {
      if (!val) {
        this.heatValue = ''
      }
    },

    // 操作热词
    handeleHeat(val) {
      if (this.heatValue && this.heatValue == val.id) {
        this.heatValue = ''
        this.search = ''
      } else {
        this.heatValue = val.id
        this.search = val.name
      }

    },

    // 筛选提交
    filterSubmit(list) {
      this.checkedTags = list
      this.handleFilter()
    },

    // 清空筛选
    handleEmpty() {
      this.checkedTags = []
      this.$refs['toolbar'].recallSelectList()
    },

    // 删除标签
    handleClose(tag, index) {
      this.checkedTags.splice(index, 1);
      this.$refs['toolbar'].recallSelectList(tag)
    },

    // 打开文件夹
    openFolder(item) {
      this.isOpenFolder = true
      this.isToolbar = false
      this.breadcrumbList.push({ id: item.id, fileName: item.fileName })
      this.$nextTick(() => {
        //console.log(this.$refs['toolbar'])
        this.$refs['fileList'].listQuery.pageNo = 1
        this.getList(item.id)
      })
    },

    // 返回上一级
    handleGoback(val) {
      if (val == '全部') {
        this.isOpenFolder = false
        this.isToolbar = true
        this.breadcrumbList = []
        this.$nextTick(() => {
          // console.log(this.$refs['toolbar'])
          this.getList()
        })
      } else {
        this.isOpenFolder = true
        this.isToolbar = false
        this.breadcrumbList.pop()
        this.$nextTick(() => {
          // console.log(this.$refs['toolbar'])
          this.getList(val)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  background: #ffffff;
}
.banner-box {
  width: 100%;
  height: 170px;
  position: relative;
  .swiper {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .img {
      width: 100%;
      height: 100%;
      // background-image: url('../../assets/banner1.png');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
    }
    ::v-deep .el-carousel__container {
      height: 170px;
    }
  }
  .search-box {
    width: 100%;
    height: 83px;
    position: absolute;
    bottom: 0;
    z-index: 2;
    text-align: center;
    .search-input {
      margin: 0 auto;
      width: 60%;
      height: 36px;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      ::v-deep .el-input__inner {
        background-color: rgba(255, 255, 255, 0.75);
      }
      .searchButn {
        font-size: 28px;
        font-weight: bold;
        margin-left: 15px;
        cursor: pointer;
      }
    }
    .search-text {
      margin-top: 7px;
      height: 40px;
      line-height: 40px;
      background-color: rgba(255, 255, 255, 0.6);
      label {
        font-size: 14px;
      }
      ::v-deep .el-radio-button__inner {
        border: 0 !important;
        border-radius: 0 !important;
        box-shadow: none !important;
        background-color: transparent !important;
        color: #000;
      }
      ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #f56c6c;
      }
    }
  }
}
</style>